import axios, { AxiosPromise } from 'axios'
import getEnvironment, { EnvironmentObject } from '@bt-react/libs/getEnvironment'
import { runPreflight } from 'twilio-video'

export const getBaseUrl = () => {
    const environment: EnvironmentObject = getEnvironment()
    return environment.domain === 'localhost' ? 'http://localhost:4200' : `https://talks.${environment.domain}`
}

export const fetchTalksPreviewAccessToken = (): AxiosPromise => {

    return axios.get(`${getBaseUrl()}/greenroom/user-auth/video-preview-twilio-token/system-preview-1/1`, { withCredentials: true })

}

export const fetchIceServers = (): AxiosPromise => {

    return axios.get(`${getBaseUrl()}/greenroom/user-auth/systemtest/`, { withCredentials: true })
}

export const startNetworkTest = async () => {
    const { data } = await fetchTalksPreviewAccessToken()
    return runPreflight(data)
}

export const startBandwidthTest = async (timeout = 10000) => {
    const twilioRtc = (await import('@twilio/rtc-diagnostics'))

    const { data } = await fetchIceServers()
    const bitrateTest = twilioRtc.testMediaConnectionBitrate(data)
    setTimeout(() => {
        bitrateTest.stop()
    }, timeout)
    return bitrateTest
}